import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                authRequired: true
            }
        },
        {
            path: '/sign-in',
            name: 'signin',
            component: () => import('./views/Signin.vue')
        },
        {
            path: '/administradores',
            name: 'administradores',
            component: () => import('./views/Administradores.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/pets',
            name: 'pets',
            component: () => import('./views/Pets.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/closebuy',
            name: 'closebuy',
            component: () => import('./views/CloseBuy.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/veterinariastest',
            name: 'veterinariastest',
            component: () => import('./views/VeterinariasPrueba.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/veterinarias',
            name: 'veterinarias',
            component: () => import('./views/Veterinarias.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/especies',
            name: 'especies',
            component: () => import('./views/Especies.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/clientes',
            name: 'clientes',
            component: () => import('./views/ClientesPublicidad.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/publicidad',
            name: 'publicidad',
            component: () => import('./views/Publicidad.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/qrcode/:qr',
            name: 'qrcode',
            component: () => import('./views/QRCode.vue')
        },

        { path: '/redirect-me', redirect: { name: 'home' } },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.idToken) {
            next({
                path: '/sign-in'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
